<template>
	<div>
		<data-table v-if="loaded"
			class="shadow-none"
			:exportable="false"
			:title="title"
			:rows="rows"
			:columns="columns"
			:perPage="perPage"
			:rowsCount="rowsCount"
			:currentPage="currentPage"
			:pageCount="pageCount"
			@rowClickDelete="pressDelete"
			@rowClickEdit="pressEdit"
			@rowClickParts="onParts"
			@rowClickItem="onItem"
			@changePage="page"
			@searchEvent="search"
			@orderByEvent="order"
			@rowClickRequests="onRequests">
		</data-table>

		<b-btn class="btn btn-dark mr-1 mt-3" @click="backTo">
			<i class="fa fa-arrow-left" aria-hidden="true"></i>
			<slot name="return"></slot>
		</b-btn>

		<b-btn class="btn btn-default mt-3" @click="pressAdd" v-if="this.$store.getters.hasPermission(['project_revisions'], ['create'])">
			<i class="fa fa-plus-circle mr-1"></i>
			<slot name="add"></slot>
		</b-btn>
	</div>
</template>

<script>
	import Vue from 'vue';
	import DataTable from '@/components/global/tables/datatables/DataTable.vue';
	import http from '@/libs/http';

	import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
	import miniToastr from 'mini-toastr';

	export default {
		name: 'revisioncontrol-table',
		components: {
			DataTable
		},
		props: {
			title: {
				type: String,
				default: ''
			},
			partsButton: {
				type: Boolean,
				default: false
			},
			itemsButton: {
				type: Boolean,
				default: false
			},
			actionWidth: {
				type: String,
				default: '105px'
			}
		},
		data() {
			return {
				request: ''
			}
		},
		methods: {
			pressDelete(row, index) {
				this.$emit("pressDelete", row, index);
			},
			pressEdit(row, index) {
				this.$emit("pressEdit", row, index);
			},
			pressAdd() {
				this.$emit("pressAdd");
			},
			onRequests (row) {
				this.$emit("pressRequest", row);
			},
			onParts (row) {
				this.$emit("pressParts", row);
			},
			onItem (row) {
				this.$emit("pressItems", row);
			},
			backTo() {
				this.$emit("pressReturn");
			},
			page(page) {
				this.currentPage=page;
				this.load(this.request);
			},
			search(input) {
				this.searchInput = input;
				this.load(this.request);
			},
			order(column, dir) {
				this.sortType = dir;
				this.sortBy = column.field;
				this.load(this.request);
			},
			load(request) {
				if(request == null || typeof request == 'undefined') {
					return;
				}
				this.request = request;
				http.route(request +'&project_id= '+ this.$route.params.id  + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get().then(response => {
					if(!response.isError) {
						this.perPage = response.pagination.limit;
						this.rowsCount = response.pagination.totalEntries;
						this.currentPage = response.pagination.currentPage;
						this.pageCount = response.pagination.totalPages;

						this.rows = response.data;

						this.rows.filter(function (value, key) {
							if(value.revision_reason_setting == null){
								value.revision_reason_setting = {id: null, key: ''};
							}
							if (value.revision_date == null) {
								value.revision_date = value.created_at;
							}
						});
						this.loaded = true;
					} else {
						Object.keys(response.errorMessage).forEach(key => {
							miniToastr.error(Vue.i18n.translate(response.errorMessage[key]), Vue.i18n.translate('messages.error'));
						});
					}
				});
			},
			refresh(page = null) {
				if (page != null) {
					if (this.currentPage > 1 && this.rows.length == 1) {
						this.currentPage += page;
					}
				}
				this.load(this.request);
			}
		},
		data() {
			return {
				loaded: false,
				perPage: 0,
				rowsCount: 0,
				pageCount: 1,
				currentPage: 1,
				searchInput: '',
				sortType: 'desc',
				sortBy: 'revision_number',

				rows: [],
				columns: [
					{
						label: Vue.i18n.translate('misc.actions'),
						width: this.actionWidth,
						showDeleteButton: true,
						showEditButton: true,
						showPartsButton: this.partsButton,
						showItemButton: this.itemsButton
					},
					{
						label: Vue.i18n.translate('table.date'),
						width: '110px',
						field: 'revision_date',
						numeric: false,
						html: false,
					},
					{
						label: Vue.i18n.translate('table.revision_number'),
						width: '150px',
						field: 'revision_number',
						numeric: false,
						html: false,
					},
					{
						label: Vue.i18n.translate('table.revision_description'),
						width: '210px',
						field: 'revision_description',
						numeric: false,
						html: false,
					},
					{
						label: Vue.i18n.translate('table.revision_reason'),
						width: '150px',
						field: 'revision_reason_setting.value',
						numeric: false,
						html: false,
					},
					{
						label: Vue.i18n.translate('table.revision_remarks'),
						field: 'revision_remarks',
						numeric: false,
						html: false,
					}
				]
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/global/tables/RevisionControlTable.vue